import {
  createRequestableState,
  handleDone,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { dashboard } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

const initialState = {
  detail: createRequestableState<dashboard.BusinessInventoryScheduleHistory>(),
  list: createRequestableState<dashboard.BusinessInventoryScheduleHistory[]>(),
};

export default function reducer(state = initialState, action: BaseTockAction) {
  switch (action.type) {
    case ClowncarAppConstants.SCHEDULE_HISTORY_FETCH_LIST_STARTING:
      return {
        ...state,
        list: handleStarting(state.list, action),
      };
    case ClowncarAppConstants.SCHEDULE_HISTORY_FETCH_LIST_DONE:
      return {
        ...state,
        list: handleDone(state.list, action),
      };
    case ClowncarAppConstants.SCHEDULE_HISTORY_FETCH_DETAIL_STARTING:
      return {
        ...state,
        detail: handleStarting(state.detail, action),
      };
    case ClowncarAppConstants.SCHEDULE_HISTORY_FETCH_DETAIL_DONE:
      return {
        ...state,
        detail: handleDone(state.detail, action),
      };
  }

  return state;
}
